import { FaWhatsapp, FaPhoneAlt } from "react-icons/fa";
import { WHATSAPP_URL, PHONE_TEL, PHONE_DISPLAY } from "../../data/config";
import "./floating.css";

export default function FloatingButtons() {
  return (
    <>
      <div className="floating-actions">
        <a
          href={PHONE_TEL}
          className="float-btn float-call"
          aria-label="Call Now"
        >
          <FaPhoneAlt />
          <span className="float-tip">Call Now</span>
        </a>
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="float-btn float-wa"
          aria-label="Chat on WhatsApp"
        >
          <FaWhatsapp />
          <span className="float-tip">WhatsApp Us</span>
        </a>
      </div>

      <a href={PHONE_TEL} className="mobile-call-bar" aria-label="Call Now">
        <FaPhoneAlt />
        <span className="mcb-label">Call Now</span>
        <span className="mcb-num">{PHONE_DISPLAY}</span>
      </a>
    </>
  );
}

